import { forwardRef, createElement } from 'react';

function IconArrowBottom(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M8.25 18h7.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5zM12 4.5a.75.75 0 01.743.648l.007.102v8.189l2.22-2.22a.75.75 0 011.133.977l-.073.084-3.5 3.5a.754.754 0 01-.078.069l.078-.069-.042.04-.052.04-.114.068-.098.038-.084.02-.088.012L12 16l-.029-.002h-.023l-.021-.003-.054-.006-.07-.015-.072-.024-.1-.047-.082-.054-.08-.069-3.5-3.5a.75.75 0 01.977-1.133l.084.073 2.22 2.219V5.25A.75.75 0 0112 4.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ArrowBottom = /*#__PURE__*/forwardRef(IconArrowBottom);

export default ArrowBottom;
//# sourceMappingURL=ArrowBottom.js.map
